// Where a signed-out visitor on /billing is sent. Somebody arriving with a plan already chosen
// (?plan=, from the pricing page) most likely has no account yet, so sign-up; anybody else
// (#renew from a reminder email, a plain /billing) signs in. The whole address — query and #hash —
// rides along as ?return=, so they land back on exactly what they opened.
export function signedOutUrl(loc = window.location) {
  const back = loc.pathname + loc.search + loc.hash;
  const to = new URLSearchParams(loc.search).has('plan') ? '/signup' : '/login';
  return `${to}?return=${encodeURIComponent(back)}`;
}

/** The plan and billing period named in the address (?plan=pro&billing=annual), or null. */
export function chosenInUrl(search = window.location.search) {
  const q = new URLSearchParams(search);
  const plan = q.get('plan');
  if (!plan) return null;
  return { plan, product: q.get('billing') === 'annual' ? 'annual' : 'monthly' };
}
